import styled from "styled-components/native";

export default styled.ScrollView.attrs({
  horizontal: true,
  showsHorizontalScrollIndicator: false,
})`
  display: flex;
  flex-direction: row;
`;
